import { tns } from 'tiny-slider/src/tiny-slider'
import 'tiny-slider/dist/tiny-slider.css'

import Mixins from '@/base/mixins'

export default class Testimonial extends Mixins {
  constructor() {
    super()
    this.slider = null
  }

  initSlider(sliderElement, controls) {
    this.slider = tns({
      container: sliderElement,
      controls: true,
      controlsContainer: controls,
      gutter: 10,
      loop: false,
      nav: true,
      navPosition: 'bottom',
      onInit: (info) => {
        info.controlsContainer.setAttribute('tabindex', -1)
        info.nextButton.setAttribute('tabindex', 0)
        info.prevButton.setAttribute('tabindex', 0)

        info.nextButton.addEventListener('keyup', this.triggerClickByEnter)
        info.prevButton.addEventListener('keyup', this.triggerClickByEnter)
      }
    })
  }
}
